<template>
  <VueRecaptcha :sitekey="this.sitekey" />
</template>
<script>
import { VueRecaptcha } from 'vue-recaptcha'
//  import Validation from '@/services/recaptchaValidate'
export default {
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      sitekey: '6LehliEnAAAAALJC681nLVc-YTjLKe3Q9dVsZdL_',
    }
  },
  methods: {
  //  validate (response) {
  //    Validation.validate({Response: response}).then(result => {
  //      this.$emit('validate', result.objectResult.success)
  //    }).catch(error => console.log(error))
  //  }
  },
}

</script>
